// @flow
import * as React from "react";

import { Routes, Route } from "react-router-dom";

import Loading from "views/components/Loading";

import GuestRoute from "views/utils/hoc/GuestRoute";
import PrivateRoute from "views/utils/hoc/PrivateRoute";

const Login = React.lazy(() => import("views/pages/Login"));
const Signup = React.lazy(() => import("views/pages/Signup"));

const EmailConfirmation = React.lazy(() => import("views/pages/EmailConfirmation"));
const ForgotPassword = React.lazy(() => import("views/pages/ForgotPassword"));
const ResetPassword = React.lazy(() => import("views/pages/ResetPassword"));
const SetPassword = React.lazy(() => import("views/pages/SetPassword"));

const OfferPreview = React.lazy(() => import("views/pages/OfferPreview"));

const LoginAsAffiliate = React.lazy(() => import("views/pages/LoginAsAffiliate"));

const Main = React.lazy(() => import("./Main"));

function Container(): React.Node {
  return (
    <div className="container-fluid py-2">
      <React.Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/login" element={<GuestRoute element={<Login />} />} />
          <Route path="/signup" element={<GuestRoute element={<Signup />} />} />
          <Route path="/email-confirmation/:token" element={<GuestRoute element={<EmailConfirmation />} />} />
          <Route path="/forgot-password" element={<GuestRoute element={<ForgotPassword />} />} />
          <Route path="/reset-password/:token" element={<GuestRoute element={<ResetPassword />} />} />
          <Route path="/set-password/:token" element={<GuestRoute element={<SetPassword />} />} />

          <Route path="/offer-previews/:id" element={<OfferPreview />} />

          <Route path="/login-as-affiliate/:id" element={<PrivateRoute element={<LoginAsAffiliate />} />} />
          <Route path="/*" element={<PrivateRoute element={<Main />} />} />
        </Routes>
      </React.Suspense>
    </div>
  );
}

export default Container;
